export const getCurrentStore = (state) => state.nposFilters.currentStore;
export const getNposFilters = (state) => state.nposFilters;
export const getNposErrors = (state) => state.nposErrors;
export const getNposValue = (state) => state.nposValues;
export const getSessionContext = (state) => state.nposValues?.sessionContext;
export const getBodyTranslations = (state) => state.localizedBody;
export const getBodyLocale = (state) => state.localizedBody?.translatedLocaleName;
export const getDefaultPrinterInfo = (state) => state.defaultPrinterInfo;
